import { Stack, Text, Paper, Group, Divider, ScrollArea } from '@mantine/core';
import { IconClipboardList, IconBook, IconBuildingFactory, IconNotes } from '@tabler/icons-react';
import React from 'react';

interface PlanRequirementsSectionProps {
  prerequisites: string;
  learningMaterials: string;
  facilitiesRequired: string;
  notes?: string;
}

const PlanRequirementsSection: React.FC<PlanRequirementsSectionProps> = ({
  prerequisites,
  learningMaterials,
  facilitiesRequired,
  notes
}) => {
  return (
    <Paper withBorder p={16} radius='lg'>
      <Stack gap={16}>
        <Group gap={8} align='center'>
          <IconClipboardList size={18} />
          <Text fw={600} size='md'>
            Requirements & Resources
          </Text>
        </Group>

        <Stack gap={16}>
          <div>
            <Group gap={4} mb={8}>
              <IconClipboardList size={14} color='gray' />
              <Text size='xs' c='dimmed' fw={500}>
                Prerequisites
              </Text>
            </Group>
            <ScrollArea.Autosize mah={80}>
              <Text size='sm' lh={1.4}>
                {prerequisites || 'No prerequisites specified'}
              </Text>
            </ScrollArea.Autosize>
          </div>

          <Divider />

          <div>
            <Group gap={4} mb={8}>
              <IconBook size={14} color='gray' />
              <Text size='xs' c='dimmed' fw={500}>
                Learning Materials
              </Text>
            </Group>
            <ScrollArea.Autosize mah={80}>
              <Text size='sm' lh={1.4}>
                {learningMaterials || 'No learning materials specified'}
              </Text>
            </ScrollArea.Autosize>
          </div>

          <Divider />

          <div>
            <Group gap={4} mb={8}>
              <IconBuildingFactory size={14} color='gray' />
              <Text size='xs' c='dimmed' fw={500}>
                Facilities Required
              </Text>
            </Group>
            <ScrollArea.Autosize mah={80}>
              <Text size='sm' lh={1.4}>
                {facilitiesRequired || 'No specific facilities required'}
              </Text>
            </ScrollArea.Autosize>
          </div>

          {notes && (
            <>
              <Divider />
              <div>
                <Group gap={4} mb={8}>
                  <IconNotes size={14} color='gray' />
                  <Text size='xs' c='dimmed' fw={500}>
                    Additional Notes
                  </Text>
                </Group>
                <ScrollArea.Autosize mah={80}>
                  <Text size='sm' lh={1.4}>
                    {notes}
                  </Text>
                </ScrollArea.Autosize>
              </div>
            </>
          )}
        </Stack>
      </Stack>
    </Paper>
  );
};

export default PlanRequirementsSection;
